<!-- 登录后的操作 -->
<template>
<van-popup v-model="show" class="login-handle-popup" position="left" :overlay-style="{background: 'rgba(0, 0, 0, 0.7)'}">
    <div class="login-handle-content">
        <div class="exit-popup">
            <img class="exit-popup-icon" @click="handleClose" :src="require('@/common/images/mSpecialTopic/loginhandle/three_line_icon.png')" />
        </div>
        <div class="user-info">
            <img class="logourl" :src="user.logourl ? user.logourl : require('@/common/images/header/user_icon.png')" />
            <div class="nickname">{{user.nickname ? user.nickname : user.mobile}}</div>
        </div>
        <div class="handle-box">
            <div class="handle-item" @click="handleOpenPopup('lxjl')">
                <img class="icon" :src="require('@/common/images/mSpecialTopic/loginhandle/ztjl_icon.png')" />
                <div class="label">做题记录</div>
            </div>
            <div class="handle-item" @click="handleOpenPopup('wdct')">
                <img class="icon" :src="require('@/common/images/mSpecialTopic/loginhandle/wdct_icon.png')" />
                <div class="label">我的错题</div>
            </div>
            <div class="handle-item" @click="handleOpenPopup('wdsc')">
                <img class="icon" :src="require('@/common/images/mSpecialTopic/loginhandle/wdsc_icon.png')" />
                <div class="label">我的收藏</div>
            </div>
        </div>
        <div class="exit-login" @click="handleExitLogin">
            <img class="icon" :src="require('@/common/images/mSpecialTopic/loginhandle/exit_icon.png')" />
            <div class="label">退出登录</div>
        </div>
    </div>
</van-popup>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
    data() {
        return {
            show: false
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleOpen() {
            this.show = true
        },
        handleClose() {
            this.show = false
        },
        handleOpenPopup(name) {
            this.handleClose()
            this.$emit('handleOpenList', name)
        },
        handleExitLogin() {
            window.sessionStorage.clear()
            let user = {
                innerid: '',
                loginToken: '',
                loginname: '',
                logourl: '',
                mobile: '',
                name: '',
                nickname: '',
                isLogin: false
            }
            this.setUser(user)
            this._delCookie('token')
            this.handleClose()
        },
        _setCookie(key, value, expiredays) {
            let exdate = new Date();
            exdate.setDate(exdate.getDate() + expiredays);
            document.cookie = key + '=' + value
            + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
            + ';path=/'
            + ';domain=' + window.location.hostname.split('.').slice(-2).join('.');
        },
        _delCookie(key) {
            this._setCookie(key, "", -1);
        },
        ...mapActions([
            'setUser'
        ])
    },
    computed: {
        ...mapGetters(['user'])
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.login-handle-popup {
    width: 4.32rem;
    height: 100vh;
    background: #F8F8F8;
    overflow: hidden;
    .login-handle-content {
        background: #fff;
        height: 100vh;
        .exit-popup {
            padding: 0.2rem;
            margin-bottom: 0.28rem;
            .exit-popup-icon {
                width: 0.32rem;
                height: 0.32rem;
            }
        }
        .user-info {
            display: flex;
            align-items: center;
            padding: 0 0.5rem 0.4rem;
            .logourl {
                width: 0.8rem;
                height: 0.8rem;
                border-radius: 50%;
                margin-right: 0.2rem;
            }
            .nickname {
                flex: 1;
                width: 0;
                font-size: 0.28rem;
                color: #333333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        .handle-box {
            height: calc(100vh - 2.2rem - 1rem);
            border-top: 0.01rem solid #E5E5E5;
            border-bottom: 0.01rem solid #E5E5E5;
            padding: 0.6rem 0.48em;
            box-sizing: border-box;
            .handle-item {
                display: flex;
                align-items: center;
                margin-bottom: 0.6rem;
                padding-left: 0.48rem;
                .icon {
                    width: 0.36rem;
                    height: 0.36rem;
                    margin-right: 0.14rem;
                }
                .label {
                    font-size: 0.28rem;
                    color: #333333;
                    line-height: 0.4rem;
                }
            }
        }
        .exit-login {
            height: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            .icon {
                width: 0.4rem;
                height: 0.4rem;
                margin-right: 0.12rem;
            }
            .label {
                font-size: 0.28rem;
                color: #666666;
            }
        }
    }
}
</style>